import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/shared/components/ui/dialog';
import { Button } from '@/shared/components/ui/button';
import { Sparkles } from 'lucide-react';

interface SmartSearchPlaceholderProps {
  open: boolean;
  onClose: () => void;
}

export function SmartSearchPlaceholder({ open, onClose }: SmartSearchPlaceholderProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex justify-center mb-4">
            <div className="p-4 bg-[#026857]/10 rounded-full">
              <Sparkles className="w-12 h-12 text-[#026857]" />
            </div>
          </div>
          <DialogTitle className="text-2xl font-bold text-center">
            Coming Soon!
          </DialogTitle>
        </DialogHeader>

        <DialogDescription asChild>
          <div className="text-center space-y-4">
            <p className="text-gray-700">
              Smart Search is under development and will be available soon.
              This AI-powered feature will help you find exactly what you need quickly and easily.
            </p>

            <p className="text-sm text-gray-600">
              In the meantime, you can browse our Pro Directory and Resource Hub using the cards below.
            </p>
          </div>
        </DialogDescription>

        <div className="flex justify-center mt-4">
          <Button
            onClick={onClose}
            className="bg-[#026857] hover:bg-[#025246] text-white"
          >
            Got it
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
